module.exports = __webpack_public_path__ + "01573086c0195c879b0fdcdd3560de9e.pdf";